/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';
import Radio from 'backbone.radio';

import lazyLoadView from '@/util/lazyLoadView';
import { validateForm } from '@/util/ParsleyUtils';
import showModal from '@/util/showModal';
import Session from '@/Session';
import showErrorMessage from '@/util/showErrorMessage';

import loadPOCGridView from '../../../external-dashboard/loaders/POCGridViewLoader';
import loadPOCDetailsModalView from '../../../external-dashboard/loaders/POCDetailsModalViewLoader';
import UpdateCommand from '../../services/UpdateCommand';

import tmplAddCommandPage from './AddCommandPage.hbs';

const AddCommandPage = View.extend({
  template: tmplAddCommandPage,

  className: 'add-command-page',

  ui: {
    formInputs: '.form-inputs',
    pointsOfContactGridContainer: '#pointsOfContactGridContainer',
    addPOC: '.add-poc',
    submitButton: '.btn-submit'
  },

  regions: {
    pointsOfContactGridContainer: '@ui.pointsOfContactGridContainer'
  },

  events: {
    'click @ui.addPOC': 'addPOC',
    'click @ui.submitButton': 'onSubmitCommand'
  },

  onRender() {
    this.showChildView(
      'pointsOfContactGridContainer',
      lazyLoadView(() => loadPOCGridView(this.model.get('commandId'), 'int-new'))
    );
  },

  addPOC(e) {
    e.preventDefault();
    showModal({
      title: 'Add Point of Contact',
      dialogClasses: 'modal-lg',
      view: lazyLoadView(() => loadPOCDetailsModalView(this.model.get('commandId'), null, false))
    }).then((formData) => {
      if (formData) {
        formData.name = `${formData.firstName} ${formData.lastName}`;
        this.getChildView('pointsOfContactGridContainer')
          .getChildView('viewContainer')
          .options.collection.unshift(formData);
      }
    });
  },

  async onSubmitCommand(e) {
    e.preventDefault();

    const spinner = Ladda.create(this.ui.submitButton[0]);
    spinner.start();
    const formData = Syphon.serialize(this);
    formData.pocs = this.getChildView('pointsOfContactGridContainer').getChildView('viewContainer').getFormData();
    try {
      await validateForm(this.ui.formInputs);
      Session.userId = formData.userName;
      const commandID = await UpdateCommand(formData);
      Radio.channel('navigate').request('show:command', commandID);
    } catch (err) {
      showErrorMessage({
        errorCode: 'submissionError',
        errorTitle: 'Submission Error',
        errorMessage:
          'An error occurred while adding command. Try again or contact an administrator if your issue persists.'
      });
    } finally {
      spinner.stop();
    }
  }
});

export default AddCommandPage;
